import { PrivacyMode } from "@shared/utils/helpers/enum.helper";

export class PrivacyModeStatus {
  bedId: string;
  pauseMode: PrivacyMode;

  constructor(privacyModeStatus: PrivacyModeStatus) {
    Object.assign(this, privacyModeStatus);
  }
}